export default __webpack_public_path__ + "static/media/corn&brat.f5093d7e.png";